import { Pipe, PipeTransform } from '@angular/core';
import { SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';

export type SafeType = 'html' | 'style' | 'script' | 'url' | 'resourceUrl';
export type SafeValue = SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl;

@Pipe({
  name: 'safe'
})
export class SafePipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(value: string, type: 'html'): SafeHtml
  transform(value: string, type: 'style'): SafeStyle
  transform(value: string, type: 'script'): SafeScript
  transform(value: string, type: 'url'): SafeUrl
  transform(value: string, type: 'resourceUrl'): SafeResourceUrl
  transform(value: string, type: SafeType): SafeValue {
    switch (type) {
      case 'html': return this.sanitizer.bypassSecurityTrustHtml(value);
      case 'style': return this.sanitizer.bypassSecurityTrustStyle(value);
      case 'script': return this.sanitizer.bypassSecurityTrustScript(value);
      case 'url': return this.sanitizer.bypassSecurityTrustUrl(value);
      case 'resourceUrl': return this.sanitizer.bypassSecurityTrustResourceUrl(value);
      default: return null;
    }
  }

}
